import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { PageHeader, Typography, Space, Divider } from 'antd';
import moment from 'moment';
import { withRouter } from 'react-router'
import style from './NewsDetail.module.css';
import request from "../../utils/NetWorkUtil";

const getData = async (url, params, headers) => {
    return request(url, {
        method: 'GET',
        params,
        headers
    });
};

const NewsDetail = (props) => {
    const { match, url, hideHeader, headers = {} } = props;
    const [newsDetail, setNewsDetail] = useState({title: '', auth: '', change_time:'', content: ''});
    const { title, auth, change_time, content } = newsDetail;

    useEffect(() => {
        (async () => {
            const { id, cateId } = match.params;
            if(id || cateId) {
                const { data } = await getData(url, {id: id || cateId}, headers);
                setNewsDetail(data)
            }
        })();
    }, [match]);

    return (
        <div className={style.wrapper}>
            {
                !hideHeader &&
                <PageHeader
                    className={style.pageHeader}
                    onBack={null}
                    title={null}
                >
                    <Typography.Title level={2}>
                        {title}
                    </Typography.Title>
                    <Space>
                        <Typography.Text strong>{auth}</Typography.Text>
                        <Typography.Text type="secondary">{`时间: ${moment(change_time).format('YYYY-MM-DD')}`}</Typography.Text>
                    </Space>
                    <Divider style={{margin: '16px 0 0 0', background: '#cccccc'}}/>
                </PageHeader>
            }
            <Typography.Paragraph style={{padding: 24}}>
                <div dangerouslySetInnerHTML={{__html: content}}/>
            </Typography.Paragraph>
        </div>
    );
};

export default connect()(withRouter(NewsDetail));
